import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-click_on_image_in_media_grid-click';
/**
 * Tracks clicks on images in the media grid in the PDP
 */
export function trackProductInfoClickOnImageInMediaGridClick(indexOfMedia, totalCountOfMedia2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { indexOfMedia, totalCountOfMedia2 },
    });
}
